import { defineMessages } from "react-intl";

export const messages = defineMessages({
  appRemoved: {
    id: "5MUqqs",
    defaultMessage: "Extension successfully removed",
    description: "app has been removed",
  },
  failedDeliveriesLogsNoLongerAvailable: {
    id: "m9I/YK",
    defaultMessage: "Failed deliveries logs are not available",
    description: "Shown when there are no available failed delivery logs for a webhook event.",
  },
});
